$(function () {

    if (".d2semlist__filterarea".length) {
        type filterObject = {
            categories: string[],
            type: string[],
            other: { [key: string]: string },
            dates: {datemin: string|undefined, datemax: string|undefined, long:number|undefined, lat: number|undefined, distance: number|undefined}
        };
        const prefilter = location.search.match(/(.*?)prefilter=(.*?)(&|$)/);
        if(prefilter && prefilter[2]){
            const filterValues = prefilter[2].split(",");
            const filteredNodes = Array.from(document.querySelectorAll("[data-filtervalue]") as NodeListOf<HTMLElement>).filter(n => filterValues.some(f => n.textContent?.trim().includes(f) || n.getAttribute("data-filtervalue")?.includes(f) || false));
            filteredNodes.forEach(node => {
                node.setAttribute("data-filteractive", "true");
                node.classList.add("d2semlist__filter--active");
            });
            const dropdownFilterValues = filterValues.filter(fv => fv.includes(":"));
            const filteredDropdowns = Array.from(document.querySelectorAll(".d2semlist__dropdown") as NodeListOf<HTMLElement>);
            filteredDropdowns.forEach(n => {
                const applicableFilter = dropdownFilterValues.find(fv => fv.split(":")[0] === n.getAttribute("data-filter"));
                if(applicableFilter){

                    n.classList.add("d2semlist__dropdown--active");
                    n.classList.remove("d2semlist__dropdown--optsvisible");
                    const s = n.querySelector(".d2semlist__dropdown__activestate span") as HTMLElement | null;
                    if(s){
                        s.innerText = decodeURIComponent(applicableFilter.split(':')[1]);
                    }
                }
            });

            const filteredDates = Array.from(document.querySelectorAll(".d2semlist__filter--input, .d2semlist__filter--input--range") as NodeListOf<HTMLElement>);
            filteredDates.forEach(n => {
                const applicableFilter = dropdownFilterValues.find(fv => fv.split(":")[0] === n.getAttribute("data-filterparameter"));
                if(applicableFilter){
                    n.classList.add("d2semlist__filter--active");
                    if (n instanceof HTMLInputElement){
                        n.value = applicableFilter.split(":")[1];
                        if (n.getAttribute("type")==="date"){
                            handleDateChange(n as HTMLInputElement, false);
                        }else if(n.getAttribute("data-filterparameter")==="location"){
                            handleLocationChange(n as HTMLInputElement, false).then(()=>{applyFilter()});
                        }else{
                            handleChange(n as HTMLInputElement, false);
                        }

                    }
                }
            });
        }

        function generateDropdownOptions(){
            const m = new Map<string, Set<string>>();
            $(".d2seminarteaser:visible").each(function(){
                const teaserData: {[key:string]: string} = $(this).data();

                for(let [key, value] of Object.entries(teaserData)){
                    if(typeof value !== 'string'){
                        continue;
                    }
                    const tokens = value.split(",");
                    for(let token of tokens){
                        const trimmed = token.trim();
                        if(trimmed === ''){
                            continue;
                        }
                        if(m.has(key)){
                            m.get(key)?.add(trimmed);
                        }
                        else{
                            const newSet = new Set<string>();
                            newSet.add(trimmed);
                            m.set(key, newSet);
                        }
                    }
                }
            });

            $(".d2semlist__dropdown").each(function(){
                $(this).find(".d2semlist__dropdown__option:not(.d2semlist__dropdown__option--dummy):not(.d2semlist__dropdown__option--back)").remove();
                const filterName = $(this).data("filter");
                const foundFilters = Array.from($(this).parents(".d2semlist").find(".d2seminarteaser:visible[data-" + filterName + "]")).flatMap(teaser => {
                    return teaser.getAttribute("data-" + filterName)?.split(",").map(s => s.trim()) || "";
                }).sort();
                const uniqueFilters = new Set(foundFilters);
                uniqueFilters.delete("");
                const options = $(this).find(".d2semlist__dropdown__options");
                const dummy = options.find(".d2semlist__dropdown__option--dummy");
                // console.log("found filters: ", foundFilters);
                // console.log("unique filters: ", uniqueFilters);
                for(let filterValue of m.get(filterName) || []){
                    const newOption = dummy.clone();
                    newOption.removeClass("d2semlist__dropdown__option--dummy");
                    newOption.text(filterValue);
                    newOption.data("value", filterValue);
                    options.append(newOption);
                }
            });
        }


        function filterAvailableOptions(){


            generateDropdownOptions();
            $(".d2semlist__resultcounter").text($(".d2seminarteaser:visible").length);
        }

        filterAvailableOptions();

        function setMinDate(){
            const today = new Date();
            today.setDate(today.getDate() +1);
            $("input.d2semlist__filter--input[type='date']").each(function(){
                $(this).attr("min", today.toISOString().split('T')[0]);
            })
        }
        setMinDate();

        function applyFilter() {
            const start = performance.now();
            let appliedFilter: filterObject = {categories: [], type: [], other: {}, dates:{datemin: undefined, datemax: undefined, long:undefined, lat: undefined, distance: undefined}};

            $(".d2semlist__filterlist[data-filterparameter='category'] [data-filtervalue]").each(function () {
                const filterValue: string = $(this).data("filtervalue") || "no filter value";
                filterValue === "no filter value" ? console.warn("missing filter value") : null;
                if ($(this).data("filteractive") === true) {
                    appliedFilter.categories.push(filterValue);
                }
            });
            $(".d2semlist__filterlist[data-filterparameter='type'] [data-filtervalue]").each(function () {
                const filterValue: string = $(this).data("filtervalue") || "no filter value";
                if ($(this).data("filteractive") === true) {
                    appliedFilter.type.push(filterValue);
                }
            });

            $(".d2semlist__dropdown--active").each(function () {
                const filterName = $(this).data("filter") || "no filter value";
                const filterValue = $(this).find(".d2semlist__dropdown__activestate span").text();
                filterName === "no filter value" ? console.warn("missing filter name") : null;
                appliedFilter.other[filterName] = filterValue;
            });

            const filterDatemin = $("input[data-filterparameter='datemin']").val()
            const filterDatemax = $("input[data-filterparameter='datemax']").val()
            const filterLocation = $("input[data-filterparameter='location']").data("filtervalue")
            const filterDistance = $("input[data-filterparameter='distance']").val()
            if (filterDatemin && filterDatemin != ""){
                appliedFilter.dates.datemin = filterDatemin.toString()
            }
            if (filterDatemax && filterDatemax != ""){
                appliedFilter.dates.datemax = filterDatemax.toString()
            }
            if (filterLocation && filterLocation != "" ){
                let jsonObj = JSON.parse(filterLocation);
                appliedFilter.dates.long=jsonObj[0];
                appliedFilter.dates.lat=jsonObj[1];
            }
            if (filterDistance && filterDistance != ""){
                if (filterDistance != 500){
                    appliedFilter.dates.distance = filterDistance as number
                }
            }



            const seminarteaser = $(".d2semlist__seminars .d2seminarteaser");
            seminarteaser.hide();

            const filteredByCategory = seminarteaser.filter((index:number, teaser: HTMLElement) => {
                let show = false;
                if(appliedFilter.categories.length === 0 || appliedFilter.categories.some(category => teaser.getAttribute("data-cat")?.includes(category) )){
                    return true;
                }
                return false;
            });

            const filteredByFormat = filteredByCategory.filter((index:number, teaser: HTMLElement) => {
                const {presence, online, inhouse } = $(teaser).data();
                if(appliedFilter.type.length === 0 || (appliedFilter.type.includes("presence") && presence === "ja") || (appliedFilter.type.includes("online") && online === "ja") || (appliedFilter.type.includes("inhouse") && inhouse === "ja") ) {
                    return true;
                }
                return false;
            });

            const filteredByOther = filteredByFormat.filter((index: number, teaser: HTMLElement) => {
                return Object.entries(appliedFilter.other).every(([key, value]):boolean => {
                    return teaser.getAttribute("data-" + key)?.includes(value) ?? false;
                })
            });

            const filteredByDates = filteredByOther.filter((index:number, teaser:HTMLElement)=>{
                if(!(appliedFilter.dates.datemin || appliedFilter.dates.datemax || appliedFilter.dates.long || appliedFilter.dates.lat)){
                    return true
                }
                if(appliedFilter.type.includes("inhouse") && $(teaser).data().inhouse === "ja"){
                    return true
                }
                let eventstring = $(teaser).data("dates");
                let matchFound = false
                if (eventstring){
                    let events = eventstring.split(",")
                    for (let event of events){
                        let isMatch=true
                        let datestring = event.split("|")[0]
                        let dateObj = new Date()
                        dateObj.setDate(parseInt(datestring.split(".")[0]))
                        dateObj.setMonth(parseInt(datestring.split(".")[1])-1)
                        dateObj.setFullYear(parseInt(datestring.split(".")[2]))
                        let date = dateObj.toISOString().split('T')[0];
                        if (appliedFilter.dates.datemin && appliedFilter.dates.datemin > date) isMatch =  false
                        if (appliedFilter.dates.datemax && appliedFilter.dates.datemax < date) isMatch = false
                        let placestring = event.split("|")[1]
                        if (appliedFilter.dates.long && appliedFilter.dates.lat && appliedFilter.dates.distance && placestring !="Online"){
                            let distance = calculateHaversineDistance(parseFloat(placestring.split("_")[0]),parseFloat(placestring.split("_")[1]),appliedFilter.dates.long, appliedFilter.dates.lat)
                            if (distance > appliedFilter.dates.distance) isMatch =  false
                        }else if(placestring === "Online" && !$(`.d2semlist__filter[data-filtervalue=online]`).hasClass("d2semlist__filter--active")){
                            isMatch = false;
                        }else if(placestring != "Online" && !$(`.d2semlist__filter[data-filtervalue=presence]`).hasClass("d2semlist__filter--active")){
                            isMatch = false;
                        }
                        if (isMatch) matchFound = true
                    }
                }
                return matchFound
            })

            filteredByDates.show();

            filterAvailableOptions();
            const end = performance.now();

            /*const semlist = document.querySelector('.d2semlist');
            if(semlist){
                window.scrollTo({top: (semlist.getBoundingClientRect().top + window.scrollY - 60)});
            }*/

           /* const t = document.querySelector("title");
            if(t) {
                t.innerText = "applyFilters() took " + (end - start) + " ms"
            }*/

            // console.log('applied');
        }

        applyFilter();


        function addUrlFilter(filter:string){
            const matcher = location.search.match(/(.*?)prefilter=(.*?)(&|$)/);

            let currentURLFilter = [];
            const newActiveFilter = filter;
            let newFilterParam = '';
            if(matcher && matcher[2]){
                currentURLFilter = matcher[2].split(",");
                currentURLFilter.push(newActiveFilter);
                newFilterParam = "?prefilter=" + currentURLFilter.join(",");
            }
            else{
                newFilterParam = "?prefilter=" + newActiveFilter;
            }
            localStorage.setItem("semfilter",location.pathname + newFilterParam);
            history.replaceState(null, document.title, location.pathname + newFilterParam);
        }

        function removeURLFilter(filter:string){
            const matcher = location.search.match(/(.*?)prefilter=(.*?)(&|$)/);
            let currentURLFilter = [];
            const filterToBeRemoved = filter;
            if(matcher && matcher[2]){
                currentURLFilter = matcher[2].split(",").filter(activeFilter => !(activeFilter.includes(filterToBeRemoved) || filterToBeRemoved.includes(activeFilter)));
                const newFilterParam = "?prefilter=" + currentURLFilter.join(",");
                if(currentURLFilter.length === 0){
                    localStorage.removeItem("semfilter");
                    history.replaceState(null, document.title, location.pathname);
                }
                else{
                    localStorage.setItem("semfilter",location.pathname + newFilterParam);
                    history.replaceState(null, document.title, location.pathname + newFilterParam);
                }

            }
        }

        $("input.d2semlist__filter[type='date']").on("change", function ():void {
            let elem = this as HTMLInputElement;
            let warn = $(elem).parent().parent().children(".d2semlist__warn")
            warn.css("display","none");
            let today = new Date()
            let year = today.getFullYear()
            if(today.toISOString().split('T')[0]< elem.value && elem.value <(year+2).toString() && (elem.value <= elem.max || elem.max==="" )&& (elem.value >= elem.min || elem.min==="")){
                handleDateChange(elem);
                applyFilter();
            }else if("1000-01-01" < elem.value){
                let warnContent = "Bitte geben Sie ein Datum innerhalb des nächsten Jahres an."
                if(elem.max != "" && elem.value > elem.max){
                    warnContent = "Bitte geben Sie ein früheres Datum an."
                }else if(elem.min!="" && elem.value < elem.min){
                    warnContent = "Bitte geben Sie ein späteres Datum an."
                }
                warn.children("span").html(warnContent)
                warn.css("display","flex");
            }
        });

        $("input.d2semlist__filter[data-filterparameter='location'] + button").on("click", function ():void {
            let inputElem = $(this).parents(".d2semlist__filter--input--wrapper").children("input.d2semlist__filter");
            handleLocationChange(inputElem.get(0) as HTMLInputElement).then(()=>{
                applyFilter();
            });

        });
        $("input.d2semlist__filter--input--range").on("change", function ():void {
            $(this).data("filterparameter") && removeURLFilter($(this).data("filterparameter"))
            if($(this).val()===$(this).attr("max")){
                $(this).removeClass("d2semlist__filter--active");
            }else{
                handleChange(this as HTMLInputElement);
            }
            applyFilter();
        });

        function handleChange(elem:HTMLInputElement, isNew = true){
            const filterValue = $(elem).val();
            const filterName = $(elem).data("filterparameter");
            if(filterValue && filterValue != ""){
                isNew && addUrlFilter(filterName + ":" + filterValue);
                $(elem).addClass("d2semlist__filter--active");
                $(elem).data("filteractive", true);
                const activeState = $(elem).parents(".d2semlist__filter--input--wrapper").children(".d2semlist__dropdown__activestate");
                activeState.children("span").html(filterValue.toString());
            }
        }

        async function handleLocationChange(elem:HTMLInputElement, isNew = true){
            const filterValue = $(elem).val();
            const filterName = $(elem).data("filterparameter");
            $(elem).parent().parent().children(".d2semlist__warn").css("display","none");
            let x = await fetch(`https://www.chefsculinar.de/getLocationFromZip?plz=${filterValue}`);
            let resObj = await x.json() as number[];
            const plz = new RegExp("\\d\\d\\d\\d\\d");
            if((filterValue && !plz.test(filterValue)) || resObj.length===0){
                $(elem).parent().parent().children(".d2semlist__warn").css("display","flex");
                return
            }else if(filterValue && filterValue != ""){
                setCategory("presence", true);
                setCategory("online", false);
                setCategory("inhouse", false);
                isNew && addUrlFilter(filterName + ":" + filterValue);
                $(elem).addClass("d2semlist__filter--active");
                $(elem).data("filteractive", "true");
                $(elem).data("filtervalue", JSON.stringify(resObj));
                elem.disabled = true;
                const activeState = $(elem).parents(".d2semlist__filter--input--wrapper").children(".d2semlist__dropdown__activestate");
                activeState.children("span").html(filterValue.toString());
            }
        }

        function handleDateChange(elem:HTMLInputElement, isNew = true){
            const filterValue = $(elem).val();
            const filterName = $(elem).data("filterparameter");
            setCategory("presence",true);
            setCategory("online", true);
            setCategory("inhouse", false);
            if($(".d2semlist__filter--input[data-filterparameter='location']").hasClass("d2semlist__filter--active")){
                setCategory("online", false);
            }
            if(filterValue && filterValue != ""){
                isNew && addUrlFilter(filterName + ":" + filterValue);
                $(elem).addClass("d2semlist__filter--active");
                $(elem).data("filteractive", "true");
                elem.disabled = true;
                const activeState = $(elem).parents(".d2semlist__filter--input--wrapper").children(".d2semlist__dropdown__activestate");
                activeState.children("span").html(new Date(filterValue.toString()).toLocaleDateString("de-DE"));
                if (filterName==="datemin"){
                    let day = new Date(filterValue.toString());
                    day.setDate(day.getDate() + 1);
                    $("input[data-filterparameter='datemax']").attr("min",day.toISOString().split('T')[0]);
                }else{
                    let day = new Date(filterValue.toString())
                    day.setDate(day.getDate() - 1);
                    $("input[data-filterparameter='datemin']").attr("max",day.toISOString().split('T')[0]);
                }
            }
        }

        $("div.d2semlist__filter").on("click", function () {

            if(!$(this).hasClass("d2semlist__filter--active")){
                addUrlFilter($(this).data("filtervalue") as string);
                if($(this).parent().hasClass("d2semlist__filterlist--singlechoice")){
                    $(this).siblings(".d2semlist__filter").each(function(){
                        $(this).removeClass("d2semlist__filter--active");
                        removeURLFilter($(this).data("filtervalue") as string);
                        $(this).data("filteractive", false);
                    })
                }
            }
            else{
                removeURLFilter($(this).data("filtervalue") as string);
                if($(this).data("filtervalue")==="presence"){
                    closeInput("location");
                }
                if($(this).data("filtervalue")==="presence" && !$(`.d2semlist__filter[data-filtervalue=online]`).hasClass("d2semlist__filter--active") ||
                    $(this).data("filtervalue")==="online" && !$(`.d2semlist__filter[data-filtervalue=presence]`).hasClass("d2semlist__filter--active")){
                    closeInput("datemin");
                    closeInput("datemax");
                }
            }
            $(this).toggleClass("d2semlist__filter--active");
            $(this).data("filteractive", !$(this).data("filteractive"));
            applyFilter();
        });

        function setFixedbutton(){
            const targetDiv = document.querySelector('.d2semlist');
            const filterButton: HTMLElement | null = document.querySelector(".d2semlist__fixedfilter");
            const list:HTMLElement | null = document.querySelector(".d2semlist");
            if(targetDiv && filterButton && list){
                filterButton.style.height = 'auto';

                const height = window.getComputedStyle(filterButton).height;

                const rect = targetDiv.getBoundingClientRect();
                if (rect.top < 80) {
                    filterButton.classList.add('d2semlist__fixedfilter--fixed');
                    list.style.paddingTop = (parseFloat(height) + 50) + 'px';

                    // console.log(list.style.paddingTop);
                } else {
                    list.style.paddingTop = '0';
                    filterButton.classList.remove('d2semlist__fixedfilter--fixed');
                }
            }
        }

        window.addEventListener('scroll', function() {
            setFixedbutton();
        });
        setFixedbutton();

        function setCategory(name:string, active:boolean){
            if (active != $(`.d2semlist__filter[data-filtervalue=${name}]`).hasClass("d2semlist__filter--active")){
                $(`.d2semlist__filter[data-filtervalue=${name}]`).trigger("click");
            }
        }

        function closeInput(name:string){
            $(`.d2semlist__filter[data-filterparameter=${name}] ~ .d2semlist__dropdown__activestate>.d2semlist__dropdown__close`).trigger("click");
        }

        $(".d2semlist__dropdown").on("click", ".d2semlist__dropdown__option:not(.d2semlist__dropdown__option--back)", function () {
            // console.log("clicked");
            const filterValue = $(this).data("value");
            const filterName = $(this).parents(".d2semlist__dropdown").data("filter");
            if(filterValue){
                addUrlFilter(filterName + ":" + filterValue);
            }
            $(this).parents(".d2semlist__dropdown").addClass("d2semlist__dropdown--active");
            $(this).parents(".d2semlist__dropdown").removeClass("d2semlist__dropdown--optsvisible");
            $(this).parents(".d2semlist__dropdown").find(".d2semlist__dropdown__activestate span").text($(this).data("value"));
            applyFilter();
        });
        $(".d2semlist__dropdown").on("click", ".d2semlist__dropdown__option--back", function () {
            $(this).parents(".d2semlist__dropdown").removeClass("d2semlist__dropdown--optsvisible");
        });

        $(".d2semlist__dropdown").on("click",".d2semlist__dropdown__close", function () {
            const filterValue = $(this).parents(".d2semlist__dropdown").data("filter");
            removeURLFilter(filterValue);
            $(this).parents(".d2semlist__dropdown").removeClass("d2semlist__dropdown--active");
            applyFilter();
        });
        $(".d2semlist__filter--input--wrapper").on("click",".d2semlist__dropdown__close", function ():void {
            const filterValue = $(this).parents(".d2semlist__filter--input--wrapper").children(".d2semlist__filter--input").val();
            filterValue && removeURLFilter(filterValue.toString());
            const inputElem = $(this).parents(".d2semlist__filter--input--wrapper").children(".d2semlist__filter--input");
            inputElem.removeClass("d2semlist__filter--active");
            inputElem.val('');
            inputElem.data("filtervalue", "");
            inputElem.prop("disabled", false);
            if (inputElem.data("filterparameter") =="location"){
                $("input[data-filterparameter='distance']").val("500");
                $("input[data-filterparameter='distance']").trigger("change")
            }
            const otherFilter = (inputElem.data("filterparameter") =="datemin"?"datemax":"datemin");
            const today = new Date();
            today.setDate(today.getDate() + 1);
            $(`input[data-filterparameter='${otherFilter}']`).attr("min", today.toISOString().split('T')[0]);
            $(`input[data-filterparameter='${otherFilter}']`).attr("max", '');
            applyFilter();
        });

        $(".d2semlist__dropdown").on("click",".d2semlist__dropdown__trigger", function () {
            $(this).parent(".d2semlist__dropdown").siblings(".d2semlist__dropdown").removeClass("d2semlist__dropdown--optsvisible");
            $(this).parents(".d2semlist__dropdown").toggleClass("d2semlist__dropdown--optsvisible");
        });

        function fixTip(){
            if(window.innerWidth > 768){
                $(".d2tooltip__tip").css("width","auto");
                const tWidth = $(".d2tooltip__tip").width() || 0;
                const tOffset = $(".d2tooltip__tip").offset()?.left || 0;
                const wWidth = $(window).width() || 0;
                if(tWidth + tOffset > wWidth){
                    $(".d2tooltip__tip").width(wWidth - tOffset - 30);
                }
            }
            else{
                $(".d2tooltip__tip").css("width","auto");
            }
        }

        $(window).on("resize", function(){
            fixTip();
        });
        fixTip();

    }


    $(".d2semlist__filtertoggle").on("click", function(){
        $(".d2semlist__filterarea").toggleClass("d2semlist__filterarea--active");
        $("body").toggleClass("d2semlist-filteractive");
    });
    $(".d2semlist__filterarea__filterapply").on("click", function(){
        $(".d2semlist__filterarea").removeClass("d2semlist__filterarea--active");
        $("body").removeClass("d2semlist-filteractive");
        const list = $(".d2seminarteaser:visible")[0];
        if(list){
            const offset = window.scrollY + list.getBoundingClientRect().top - 120;
            window.scrollTo(0,offset);
        }
    });


    $("[data-seminardropdown]").on("click", function () {
        const tar = $(this).data("seminardropdown");
        if (tar !== undefined) {
            $(`[data-seminardropdownid='${tar}']`).toggleClass('d2seminar__dates__date__dropdown--active');
        }
    });

    if($(".d2seminar").length && $(".relaunch-to-overview").length && localStorage.getItem("semfilter")){
        $(".relaunch-to-overview").attr("href",  localStorage.getItem("semfilter"));
    }

    function calculateHaversineDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
        const R: number = 6371; // Erdradius in Kilometern
        const toRad = (angle: number): number => {
            return angle * Math.PI / 180;
        };
        const radLat1: number = toRad(lat1);
        const radLat2: number = toRad(lat2);
        const deltaLat: number = toRad(lat2 - lat1);
        const deltaLon: number = toRad(lon2 - lon1);
        // Haversine-Formel
        const a: number = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
            Math.cos(radLat1) * Math.cos(radLat2) *
            Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);
        const c: number = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c * 1.3; // Entfernung in Kilometern mit Faktor für Fahrtdistanz
    }

    let currentActiveFormID: null | string = null;
    let formmode: null | string = null;

    $(".d2seminar__dates__date__toggleform").on("click", function () {
        $("body").addClass("d2semformactive");
        const fw = $(".d2semform:not(.d2semform--inhouse) .d2semform__formwrapper");
        currentActiveFormID = $(this).data("dateid") || '';
        if (currentActiveFormID === '') {
            console.warn('no date id could be read');
            return;
        }
        const datenode = $("[data-seminardropdown='" + $(this).data("dateid") + "']").eq(0).parents(".d2seminar__dates__date");// $(this).parents(".d2seminar__dates__date");
        const start = datenode.data("start");
        const end = datenode.data("end");
        const place = datenode.data("place");
        const followup = datenode.data("followup");
        const price = datenode.data("price");
        const customerprice = datenode.data("customerprice");

        fw.find(".d2semform__customerprice").text(customerprice);
        fw.find(".d2semform__noncustomerprice").text(price);


        fw.find(".d2semform__form__semdata__data--date").html(start + (end ? ' - ' + end :
            ''));
        fw.find(".d2semform__form__semdata__data--place").text(place);
        if (followup) {
            fw.find(".d2semform__form__semdata__data--followup").text(followup);
            fw.find(".d2semform__form__semdata__data--followup").parent().show();
        } else {
            fw.find(".d2semform__form__semdata__data--followup").parent().hide();
        }
        // console.logconsole.log('dateid', currentActiveFormID);
    });
    $(".d2semform__close").on("click", function () {
        currentActiveFormID = null;
        $("body").removeClass("d2semformactive d2semforminhouseactive");
    });

    $(".d2seminar__inhousetrigger").on("click", function () {
        $("body").addClass("d2semforminhouseactive");
    });

    $(".d2semform #iscustomer").on("change", function () {
        if ($(this).is(":checked")) {
            $(this).parents(".d2semform").find(".d2semform__customerprice").css("display","inline");
            $(this).parents(".d2semform").find(".d2semform__noncustomerprice").css("display","none");
        }
        else{
            $(this).parents(".d2semform").find(".d2semform__customerprice").css("display","none");
            $(this).parents(".d2semform").find(".d2semform__noncustomerprice").css("display","inline");
        }
    });

    type errorResponseType = { status: string, attribs: { attr: string, isValid: boolean }[] };

    $(".d2semform .d2semformsubmit").on("click", function () {

        const fw = $(this).parents(".d2semform__formwrapper");

        if ((fw).length === 0) {
            console.error("could not find formwrapper", {jquerynode: fw});
            return;
        }

        const form = $(this).parents(".d2semform");
        formmode = $(this).parents(".d2semform").hasClass("d2semform--inhouse") ? "inhouse" : "default";
        if (formmode === "inhouse") {
            const data = {
                title: fw.find("[name='title_inhouse']").val(),
                firstname: fw.find("[name='firstname_inhouse']").val(),
                lastname: fw.find("[name='lastname_inhouse']").val(),
                email: fw.find("[name='email_inhouse']").val(),
                phone: fw.find("[name='phone_inhouse']").val(),
                company: fw.find("[name='company_inhouse']").val(),
                function: fw.find("[name='function_inhouse']").val(),
                calltime: fw.find("[name='calltime_inhouse']").val(),
                agb: fw.find("[name='agb_inhouse']").is(":checked"),
                datenschutz: fw.find("[name='datenschutz_inhouse']").is(":checked"),
                newsletter: fw.find("[name='newsletter_inhouse']").is(":checked")
            };
            $.ajax({
                url: "seminarRequestInhouse.json?nocache=" + new Date().getTime(),
                method: "POST",
                data: {
                    test: 1338,
                    dateid: currentActiveFormID,
                    ...data
                },
                error: function (res) {
                    const resJson = res.responseJSON as errorResponseType;
                    const errorFields = [];
                    for (let attrib of resJson.attribs) {
                        const selector = '[name=' + attrib.attr + ']';
                        const field = fw.find(selector);
                        if (attrib.isValid === false) {
                            field.siblings('.input-invalid-help').show();
                            field.addClass('input-invalid');
                            if (field.length) {
                            }
                            errorFields.push(field[0]);
                        } else {
                            field.siblings('.input-invalid-help').hide();
                            field.removeClass('input-invalid');
                        }
                    }
                    const firstErrorOffset = errorFields.reduce((prev, curr) => {
                        if (prev < curr.getBoundingClientRect().top) {
                            return prev;
                        }
                        return curr.getBoundingClientRect().top;
                    }, 0)
                    fw.parents(".d2semform").animate({
                        scrollTop: (fw.parents(".d2semform").scrollTop() || 0) + firstErrorOffset
                    }, 0);

                },
                success: function (res) {
                    form.find(".d2semform__form").addClass("d2semform__form--hide");
                    form.find(".d2semform__thanks").addClass("d2semform__thanks--show");
                }
            });
        } else {
            const data = {
                title: fw.find("[name='title']").val(),
                firstname: fw.find("[name='firstname']").val(),
                lastname: fw.find("[name='lastname']").val(),
                email: fw.find("[name='email']").val(),
                phone: fw.find("[name='phone']").val(),
                company: fw.find("[name='company']").val(),
                function: fw.find("[name='function']").val(),
                street: fw.find("[name='street']").val(),
                hs: fw.find("[name='hs']").val(),
                plz: fw.find("[name='plz']").val(),
                city: fw.find("[name='city']").val(),
                iscustomer: fw.find("[name='iscustomer']").is(":checked"),
                customernumber: fw.find("[name='customernumber']").val(),
                agb: fw.find("[name='agb']").is(":checked"),
                datenschutz: fw.find("[name='datenschutz']").is(":checked"),
                newsletter: fw.find("[name='newsletter']").is(":checked")
            };
            $.ajax({
                url: "seminarRequest.json?nocache=" + new Date().getTime(),
                method: "POST",
                data: {
                    test: 1338,
                    dateid: currentActiveFormID,
                    ...data
                },
                error: function (res) {
                    const resJson = res.responseJSON as errorResponseType;
                    const errorFields = [];
                    for (let attrib of resJson.attribs) {
                        const selector = '[name=' + attrib.attr + ']';
                        const field = fw.find(selector);
                        if (attrib.isValid === false) {
                            field.siblings('.input-invalid-help').show();
                            field.addClass('input-invalid');
                            if (field.length) {
                            }
                            errorFields.push(field[0]);
                        } else {
                            field.siblings('.input-invalid-help').hide();
                            field.removeClass('input-invalid');
                        }
                    }
                    const firstErrorOffset = errorFields.reduce((prev, curr) => {
                        if (prev < curr.getBoundingClientRect().top) {
                            return prev;
                        }
                        return curr.getBoundingClientRect().top;
                    }, 0)
                    fw.parents(".d2semform").animate({
                        scrollTop: (fw.parents(".d2semform").scrollTop() || 0) + firstErrorOffset
                    }, 0);

                },
                success: function (res) {
                    form.find(".d2semform__form").addClass("d2semform__form--hide");
                    form.find(".d2semform__thanks").addClass("d2semform__thanks--show");
                }
            });
        }


    });

    $(".d2inhousecta__close").on('click', function () {
        $(this).parent().hide();
    })
});